export const uiConstants = {
  OPEN_DRAWER: 'DRAWER_OPEN_DRAWER',

  SET_FILTER: 'TABLE_SET_FILTER',
}
